// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iziToast>.iziToast-body{align-items:center;display:flex}.iziToast>.iziToast-body .iziToast-texts{float:unset;margin:0}.iziToast>.iziToast-body .iziToast-buttons{float:unset;margin-left:auto}.iziToast.iziToast-theme-dark .iziToast-message{line-height:unset!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
